<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:item.action="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="abrirPOS(item)">
                  <v-icon>mdi-alpha-p-circle</v-icon>
                </v-btn>
            </template>
            <span>POS</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="abrirIBPT(item)">
                  <v-icon>mdi-file-upload</v-icon>
                </v-btn>
            </template>
            <span>Tabela de alíquota de impostos</span>
          </v-tooltip>
          <!--v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="abrirPontosDeVenda(item)">
                <v-icon>mdi-cash-register</v-icon>
              </v-btn>
            </template>
            <span>Pontos de venda (PDV)</span>
          </v-tooltip-->
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="abrirPrazos(item)">
                <v-icon>mdi-numeric-9-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Prazos para pagamentos</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="atualizarCertificado(item)">
                <v-icon>mdi-file-certificate</v-icon>
              </v-btn>
            </template>
            <span>Certificado</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="abrirSMTP(item)">
                <v-icon>mdi-mail</v-icon>
              </v-btn>
            </template>
            <span>SMTP</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" class="mr-1" @click="replicarFilial(item)">
                <v-icon>mdi-transfer</v-icon>
              </v-btn>
            </template>
            <span>Replicar dados</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab v-on="on" color="primary" @click="editar(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-card outlined>

        <v-toolbar flat color="accent">
          <v-toolbar-title>Cadastrar/Alterar Empresa
            <v-chip
            color="primary"
              v-if="filial.id_reg != undefined"
              close
              @click:close="resetarFormulario()">
              {{ filial.cc_ins_fed }}, {{ filial.nm_fil }}
            </v-chip>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form  ref="form" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field
                        label="Código" 
                        :disabled="disabled"
                        v-model="filial.cc_fil" 
                        :rules="validacao.cc_fil" 
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="7">
                    <v-text-field 
                        label="Razão Social"
                        v-model="filial.nm_fil"
                        :rules="validacao.nm_fil"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="3">
                    <v-select 
                        item-text="nm_cc_reg_tri" 
                        item-value="cc_reg_tri"
                        label="Regime Tributário"
                        :items="cc_reg_tri_list"
                        v-model="filial.cc_reg_tri"
                        :rules="validacao.cc_reg_tri"
                        required></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="2">
                    <v-text-field 
                        label="CNPJ"
                        v-model="filial.cc_ins_fed"
                        :rules="validacao.cc_ins_fed"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="6">
                    <v-text-field 
                        label="Inscrição Estadual"
                        v-model="filial.cc_ins_est"
                        :rules="validacao.cc_ins_est"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="2">
                    <v-text-field 
                    label="Inscrição Municipal"
                    v-model="filial.cc_ins_mun"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="2">
                    <v-text-field 
                        label="CNAE"
                        v-model="filial.cc_cna_fis"></v-text-field>
                </v-col>
              </v-row>
              <h3>Endereço</h3>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field 
                    label="CEP"
                    v-model="filial.cc_end_cpt"
                    :rules="validacao.cc_end_cpt"
                    required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                    <v-text-field 
                        label="Logradouro"
                        v-model="filial.tx_end_log"
                        :rules="validacao.tx_end_log"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field 
                        label="Número"
                        v-model="filial.tx_end_num"
                        :rules="validacao.tx_end_num"
                        required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <v-text-field 
                        label="Complemento"
                        v-model="filial.tx_end_cmp"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" >
                    <v-text-field 
                        label="Bairro"
                        v-model="filial.tx_end_bai"
                        required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <v-text-field 
                        label="Telefone"
                        v-model="filial.tx_end_tel"
                        :rules="validacao.tx_end_tel"
                        required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select 
                        label="Estado"
                        item-text="nm_est"
                        item-value="cc_est"
                        :items="cc_end_est_list"
                        v-model="filial.cc_end_est"
                        :rules="validacao.cc_end_est"
                        required></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select 
                        item-text="nm_mun"
                        item-value="nm_mun"
                        :items="cc_end_mun_list"
                        label="Municipio"
                        v-model="filial.tx_end_mun_nom"
                        :rules="validacao.tx_end_mun_nom"
                        required></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-text-field 
                        label="Código Município"
                        v-model="filial.cc_end_mun_cod" 
                        :rules="validacao.cc_end_mun_cod"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn depressed outlined color="primary" @click="salvar()">{{ filial.id_reg != undefined ? 'CONFIRMAR ALTERAÇÕES' : 'CONFIRMAR INSERÇÃO'}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <!--/v-alert-->
      <pm-replica :filial='replicacao.filial' :modal='replicacao.modal' :key="replicacao.key" v-on:a="replicacao.modal=false;replicacao.filial=undefined"></pm-replica>
      <pm-certificado :filialId='certificado.filialId' :modal="certificado.modal" :key="certificado.key" v-on:a="certificado.modal=false;certificado.filialId=null"></pm-certificado>
      <pm-ponto-de-venda :filial='pontoDeVenda.filial' :modal='pontoDeVenda.modal' :key="pontoDeVenda.key" v-on:a="pontoDeVenda.modal=false;pontoDeVenda.filial=undefined"></pm-ponto-de-venda>
      <pm-prazo :filial='prazo.filial' :modal='prazo.modal' :key="prazo.key" v-on:a="prazo.modal=false;prazo.filial=undefined"></pm-prazo>
      <pm-ibpt :filial='ibpt.filial' :modal='ibpt.modal' :key="ibpt.key" v-on:a="ibpt.modal=false;ibpt.filial=undefined"></pm-ibpt>
      <pm-pos :filial='pos.filial' :modal='pos.modal' :key="pos.key" v-on:a="pos.modal=false;pos.filial=undefined"></pm-pos>
      <pm-smtp :filial='smtp.filial' :modal='smtp.modal' :key="smtp.key" v-on:a="pos.modal=false;smtp.filial=undefined"></pm-smtp>
  </div>
</template>
<script>
  import lodash from 'lodash'
  import Replica from './Replica.vue'
  import Certificado from './Certificado.vue'
  import PontoDeVenda from './PontoDeVenda.vue'
  import Prazo from './Prazo.vue'
  import IBPT from './IBPT.vue'
  import POS from './POS.vue'
  import SMTP from './Smtp.vue'
  export default {

    name: 'Filial',

    components: {
      'pm-replica': Replica,
      'pm-certificado': Certificado,
      'pm-ponto-de-venda': PontoDeVenda,
      'pm-prazo': Prazo,
      'pm-ibpt': IBPT,
      'pm-pos': POS,
      'pm-smtp': SMTP
    },

    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Código', value: 'cc_fil', sortable:false, width: 80 },
          { text: 'CNPJ', value: 'cc_ins_fed', sortable:false, width: 100 },
          { text: 'Razão Social', value: 'nm_fil', sortable:false },
          { text: '', value: 'action', sortable:false, width: 380, align: 'right' },
        ],

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        cc_end_mun_list: [],
        cc_end_est_list: [],
        cc_reg_tri_list: [],

        filial:{
          id_reg:null,
          cc_fil:'',
          nm_fil:'',
          cc_reg_tri:'',
          cc_ins_fed:'',
          cc_ins_est:'',
          cc_ins_mun:'',
          cc_cna_fis:'',
          cc_end_cpt:'',
          tx_end_log:'',
          tx_end_num:'',
          tx_end_cmp:'',
          tx_end_bai:'',
          tx_end_tel:'',
          cc_end_est:'',
          tx_end_mun_nom:'',
          cc_end_mun_cod:'',
          tx_end_pai_nom:'BRASIL',
          cn_end_pai_cod:'1058',
          st_fil:'E0',
        },

        validacao: {
          cc_fil: [
              (v) => !!v || 'Requerido',
              (v) => /^[A-Z0-9]{3,10}$/.test(v) || 'Formato inválido'
          ],
          nm_fil: [
              v => !!v || 'Requerido'
          ],
          cc_reg_tri: [
              v => !!v || 'Requerido'
          ],
          cc_ins_fed: [
              (v) => !!v || 'Requerido',
              (v) => /^[0-9]{14}$/.test(v) || 'Formato inválido'
          ],
          cc_ins_est: [
              (v) => !!v || 'Requerido',
              (v) => /^[0-9]+$/.test(v) || 'Formato inválido'
          ],
          cc_end_cpt: [
              (v) => !!v || 'Requerido',
              (v) => /^[0-9]{8}$/.test(v) || 'Formato inválido'
          ],
          tx_end_log: [
              v => !!v || 'Requerido'
          ],
          tx_end_num: [
              (v) => !!v || 'Requerido',
              (v) => /^S\/N$|^[0-9]{1,6}$/.test(v) || 'Formato inválido'
          ],
          tx_end_tel: [
              (v) => !!v || 'Requerido',
              (v) => /^\([0-9]{2}\) ([0-9]{5}|[0-9]{4})-[0-9]{4}$/.test(v) || 'Formatos válidos: (##) ####-#### ou (##) #####-####'
          ],
          cc_end_est: [
              v => !!v || 'Requerido'
          ],
          tx_end_mun_nom: [
              (v) => !!v || 'Requerido'
          ],
          cc_end_mun_cod: [
              (v) => !!v || 'Requerido',
              (v) => /^[0-9]{7}$/.test(v) || 'Formato inválido'
          ]
        },

        /** dados replicados */
        replicacao: {
          modal: false,
          filial: undefined,
          key: undefined
        },

        /** certificado */
        certificado: {
          modal: false,
          filialId: undefined,
          key: undefined
        },

        /** ponto de venda */
        pontoDeVenda: {
          modal: false,
          filial: undefined,
          key: undefined
        },

        /** ponto de venda */
        prazo: {
          modal: false,
          filial: undefined,
          key: undefined
        },

        /** ibpt */
        ibpt: {
          modal: false,
          filial: undefined,
          key: undefined
        },

        /** ibpt */
        pos: {
          modal: false,
          filial: undefined,
          key: undefined
        },

        smtp: {
          modal: false,
          filial: undefined,
          key: undefined
        },

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
      'filial.cc_end_est'() {
        if(this.filial.cc_end_est != undefined && this.filial.cc_end_est != ''){
          this.populaMunicipio()
        }
      }
    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaRegimeTributario()
      this.populaEstado()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    methods: {

      editar(obj){
        this.disabled = true
        this.filial = lodash.clone(obj)
        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      salvar() {

        this.$vuetify.goTo(0)

        if (this.$refs.form.validate()) {

          if (this.filial.cc_ins_mun === undefined) this.filial.cc_ins_mun = ''
          if (this.filial.tx_end_cmp === undefined) this.filial.tx_end_cmp = ''
          if (this.filial.cc_cna_fis === undefined) this.filial.cc_cna_fis = ''
          if (this.filial.tx_end_bai === undefined) this.filial.tx_end_bai = ''

          // eslint-disable-next-line no-unused-vars
          this.$store.dispatch('salvarFilial', this.filial).then(resp => {

            if(this.filial.id_reg !== undefined) {
              let item = this.itens.filter((el) => {return el.id_reg === this.filial.id_reg})
              if(item.length > 0){
                Object.assign(this.itens[this.itens.indexOf(item[0])], this.filial)
              }
            }

            this.resetarFormulario()
          }).catch(err => {
            console.log(err)
          })

        }
      },

      resetarFormulario() {
        this.disabled = false
        this.filial.id_reg = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaRegimeTributario() {
      this.$store.dispatch('getRegimeTributario', {})
        .then(resp => {
            this.cc_reg_tri_list = resp.data
        })
        .catch(err => console.log(err.response.request))
      },

      populaEstado() {
        this.$store.dispatch('getEstados', {})
          .then(resp => {
              this.cc_end_est_list = resp.data
          })
          .catch(err => console.log(err))
      },

      populaMunicipio() {
        this.$store.dispatch('getMunicipios', {cc_est: this.filial.cc_end_est})
          .then(resp => {
              this.cc_end_mun_list = resp.data
          })
          .catch(err => console.log(err))
      },

      replicarFilial(item) {
        this.replicacao.key = Math.random() * Math.random()
        this.replicacao.modal = true
        this.replicacao.filial = item
      },

      atualizarCertificado(item) {
        this.certificado.key = Math.random() * Math.random()
        this.certificado.filialId = item.id_reg
        this.certificado.modal = true
      },

      abrirPontosDeVenda(item) {
        this.pontoDeVenda.key = Math.random() * Math.random()
        this.pontoDeVenda.filial = item
        this.pontoDeVenda.modal = true
      },

      abrirPrazos(item) {
        this.prazo.key = Math.random() * Math.random()
        this.prazo.filial = item
        this.prazo.modal = true
      },

      abrirIBPT(item) {
        this.ibpt.key = Math.random() * Math.random()
        this.ibpt.filial = item
        this.ibpt.modal = true
      },

      abrirPOS(item) {
        this.pos.key = Math.random() * Math.random()
        this.pos.filial = item
        this.pos.modal = true
      },

      abrirSMTP(item) {
        this.smtp.key = Math.random() * Math.random()
        this.smtp.filial = item
        this.smtp.modal = true
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage,
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisarFilial', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>